import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/src/components/auth/auth-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientLayout"] */ "/workspace/src/components/layout/client-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/workspace/src/components/ui/toaster.tsx");
